
jQuery(function() {
  jQuery('.js-transport-chart-mobile-buttons [data-transport-chart-item]').click(function() {
    jQuery('[data-transport-chart-item].mobile-active').removeClass('mobile-active');
    var selectedItem = jQuery(this).attr('data-transport-chart-item');
    jQuery('[data-transport-chart-item="' + selectedItem + '"]').addClass('mobile-active');
  });
});
